import Deadline from './deadline';

export const CompetitionMetric = Object.freeze({
    ASC: 'ascending',
    DESC: 'descending',
    values() {
        return ['ascending', 'descending'];
    }
});

export class CompetitionSettingDeadline extends Deadline {
    constructor({
        id = null,
        date = '',
        evaluation_type = '',
        homework_id = null,
        points = 0 // Default points to 0
    }) {
        super({ id, date, evaluation_type, homework_id });
        this.id = id;
        this.points = points;
    }
}

export class CompetitionSettingBonus {
    constructor({
        id = null,
        title = '',
        subtask_id = null,
        points = 0, // Default points to 0
        prefix = '',
        metric = CompetitionMetric.ASC, // Default metric to ASC
        top_k = 1 // Default top_k to 1
    }) {
        this.id = id;
        this.title = title;
        this.subtask_id = subtask_id;
        this.points = points;
        this.prefix = prefix;
        this.metric = metric;
        this.top_k = top_k;
    }

    static validate(bonusData) {
        if (!bonusData.title) throw new Error('Title is required');
        if (bonusData.subtask_id == null) throw new Error('Subtask ID is required');
        if (!CompetitionSetting.validatePoints(bonusData.points)) throw new Error('Points must be a non-negative integer');
        if (!bonusData.prefix && bonusData.prefix !== '') throw new Error('Prefix is required');
        if (!CompetitionMetric.values().includes(bonusData.metric)) throw new Error('Invalid metric value');
        if (!Number.isInteger(bonusData.top_k) || bonusData.top_k < 1) throw new Error('top_k must be an integer >= 1');
    }
}

export class CompetitionSettingHomework {
    constructor({
        id = null,
        title = '',
        release_date = '',
        in_competition = false,
        deadlines = [],
        bonuses = []
    }) {
        this.id = id;
        this.title = title;
        this.release_date = release_date;
        this.in_competition = in_competition;
        this.deadlines = (deadlines || []).map(d => new CompetitionSettingDeadline(d));
        this.bonuses = (bonuses || []).map(b => new CompetitionSettingBonus(b));
    }

    static validate(homeworkData) {
        if (!homeworkData.title) {
            throw new Error('Title is required');
        }
        if (!homeworkData.release_date) {
            throw new Error('Release date is required');
        }
        if (Array.isArray(homeworkData.deadlines)) {
            homeworkData.deadlines.forEach(d => {
                if (!CompetitionSetting.validatePoints(d.points)) {
                    throw new Error('Deadline points must be a non-negative integer');
                }
            });
        }
        if (Array.isArray(homeworkData.bonuses)) {
            homeworkData.bonuses.forEach(CompetitionSettingBonus.validate);
        }
    }
}

export default class CompetitionSetting {
    constructor({ homeworks = [] }) {
        this.homeworks = (homeworks || []).map(h => new CompetitionSettingHomework(h));
    }

    static validate(settingData) {
        if (!Array.isArray(settingData.homeworks)) {
            throw new Error('Homeworks must be an array');
        }
    }

    static validatePoints(points) {
        // Points must be a non-negative integer
        return Number.isInteger(points) && points >= 0;
    }
}
